import { useSelector, useDispatch } from 'react-redux';
import { Tab } from '@mui/material';
import BankDetailsManage from './bank-details/BankDetailsManage';
import TaxInvoiceDetailManage from './tax-invoice/TaxInvoiceDetailManage';
import GeneralSettings from './general/General';
import CommissionDetails from './commission-details/CommissionDetails';
import { setEventSettingActiveTab } from '../../../../../app/store/slices/event/settings/eventSettings';
import '../../../../../styles/components/Invitation.css';
import '../../../../../styles/components/CreateEvent.css';

export default function EventSettings() {
    const dispatch = useDispatch();
    const activeTab = useSelector((state) => state.eventSettings.activeTab);

    return (
        <section id="create-event-tickets-section">
            <div className="event-creation-stepper">
                <Tab
                    label="Bank Details"
                    variant={activeTab === 'bankDetails' ? 'main' : 'inactive'}
                    onClick={() => dispatch(setEventSettingActiveTab('bankDetails'))}
                />
                <Tab
                    label="Tax Invoices"
                    variant={activeTab === 'taxInvoice' ? 'main' : 'inactive'}
                    onClick={() => dispatch(setEventSettingActiveTab('taxInvoice'))}
                />
                <Tab
                    label="Commission Details"
                    variant={activeTab === 'commission' ? 'main' : 'inactive'}
                    onClick={() => dispatch(setEventSettingActiveTab('commission'))}
                />
                <Tab
                    label="General"
                    variant={activeTab === 'general' ? 'main' : 'inactive'}
                    onClick={() => dispatch(setEventSettingActiveTab('general'))}
                />
            </div>
            <div className="event-creation-tabs-content">
                {activeTab === 'bankDetails' && <BankDetailsManage />}
                {activeTab === 'taxInvoice' && <TaxInvoiceDetailManage />}
                {activeTab === 'general' && <GeneralSettings />}
                {activeTab === 'commission' && <CommissionDetails />}
            </div>
        </section>
    );
}